import React from 'react';
import { Helmet } from 'react-helmet-async';
import LegalPageLayout from '@/components/legal/LegalPageLayout';
import { privacyContent } from '@/content/legal/privacy';

const PrivacyPolicy: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy | Zentrix Insights</title>
        <meta name="description" content="Learn how Zentrix Insights collects, uses, and protects your personal and assessment data. GDPR and CCPA compliant." />
        <meta property="og:title" content="Privacy Policy | Zentrix Insights" />
        <meta property="og:description" content="Learn how Zentrix Insights collects, uses, and protects your personal and assessment data." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://zentrixinsights.com/privacy" />
      </Helmet>
      <LegalPageLayout {...privacyContent} />
    </>
  );
};

export default PrivacyPolicy;
